import { createFileRoute } from '@tanstack/react-router';
import { BlogIndexPage } from '../../../pages/blog/BlogIndexPage';
import { staticPageHead } from '../../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/blog/')({
  head: () =>
    staticPageHead({
      path: '/blog',
      title: 'The AnyAPI blog: runnable guides for pulling data from anywhere',
      description:
        'Runnable guides, data teardowns, and field notes from the team running the gateway. Code you can paste, numbers you can check.',
      crumb: 'Blog',
      og: { title: 'The AnyAPI blog', type: 'website' },
    }),
  component: () => <BlogIndexPage />,
});
